import { onMounted, onUnmounted, ref } from "vue"

const headerPadding = ref(0)
const isHeaderVisible = ref(true)

export const useAppHeader = () => ({ headerPadding, isHeaderVisible })

/**
 * Call from a view that renders its own header content through
 * `<Teleport to="#app-header" defer>`. The default content comes back
 * automatically when the view unmounts.
 */
export const useAppHeaderTakeover = () => {
  onMounted(() => (isHeaderVisible.value = false))
  onUnmounted(() => (isHeaderVisible.value = true))
}
